export function translateRemovePointOnMark(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  //  do(remove_point_on_mark,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Remove point marks in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "modify",
      option: {
        point: null
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddPointOnMark(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  //  do(add_point_on_mark,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add point marks in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "modify",
      option: {
        point: true
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateRemoveEndMark(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  //  do(remove_end_mark,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Remove point marks in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "modify",
      option: {
        endMark: null
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddEndMark(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  //  do(add_end_mark,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add point marks in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "modify",
      option: {
        endMark: {
          type: "circle",
          size: {
            value: 90
          }
        }
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateConvertAreaToLine(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_area_to_line,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Convert area mark to line in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "modify",
      option: {
        mark: "line"
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateConvertLineToArea(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_line_to_area,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Convert area mark to line in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark",
        mark: "line"
      },
      action: "modify",
      option: {
        mark: "area",
        line: true
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateInvertCircleMark(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(invert_circle_mark,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: "Invert the fill and stroke of circle marks",
      specifier: {
        role: "mark",
        mark: "circle"
      },
      action: "modify",
      option: {
        opacity: { value: 1 },
        fillOpacity: { value: 0.1 },
        stroke: { value: layer.mark?.fill?.value || "rgb(0,0,0)" }
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: mapping[args[0]]?.layer };
    }
    rules.push(rule)
  }
  return rules;
}